export type TimeScale = 15 | 30 | 60 | 120;
export const TimeScales: TimeScale[] = [15, 30, 60, 120];
